import {Button, Layout, Tabs, Typography} from 'antd';
import {React, useState} from 'react';
import appColors from '../../style/theme';
import CaC from './CaC';
import ELONA from './ELONA';

const {Paragraph, Text} = Typography;
const {Content} = Layout;

const StanTabs = () => {
  const [TAUno, setTAUno] = useState('white');
  const [GAUno, setGAUno] = useState(appColors['ColorX']);
  // others
  const [TUno, setTUno] = useState(appColors['ColorX']);
  const [GUno, setGUno] = useState(appColors['ColorG2']);

  const changeColor1 = (key) => {
    if (key === 'uno') {
      setTAUno('white');
      setGAUno(appColors['ColorX']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
    } else if (key === 'dos') {
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno('white');
      setGUno(appColors['ColorX']);
    }
  };
  const items_ = [
    {label: <Button style={{height: '13vh', top: '2.3vh', fontSize: '4vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TAUno, fontWeight: 'bold', borderColor: GAUno, background: GAUno}}>ELONA</Button>, key: 'uno', children: <ELONA/>},
    {label: <Button style={{height: '13vh', top: '2.3vh', fontSize: '3.5vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TUno, fontWeight: 'bold', borderColor: GUno, background: GUno}}>Assembly and Running<br/>of the lateral flow</Button>, key: 'dos', children: <CaC/>},
  ];
  return (
    <Layout style={{margin: '5.2vh 5.2vh 4.2vh 5.2vh', background: 'transparent'}}>
      <Paragraph className= 'Title3' style={{color: appColors['ColorX'], marginTop: '-15vh', fontSize: '5vh'}}>Correlation between aptamer/biomarker concentration and colorimetric signal</Paragraph>
      <Text className='BaseText'>After characterizing the interaction of aptamer-protein and the modifications of the aptamers, the third and final phase of our experimental pipeline is to determine the correlation between aptamer and biomarker concentrations with the colorimetric signal we observed. In this stage we want to test our system assembly and evaluate the minimum and maximum concentration of protein that our system can detect with different types of sample (blood, serum and plasma).</Text>
      <Content style={{padding: '2vh', background: 'transparent'}}>
        <Tabs
          tabBarGutter='4vh'
          defaultActiveKey="1"
          size='large'
          items={items_}
          onTabClick={changeColor1}
        />
      </Content>
    </Layout>
  );
};

export default StanTabs;
